// extracted by mini-css-extract-plugin
export default {"nav_list":"NavLinks_nav_list__j2W9D","nav_list__item":"NavLinks_nav_list__item__vwI+8"};